import { H4, YStack } from "tamagui";

export function ManagedScanner() {
  return (
    <YStack ai="center" jc="center" flex={1} minHeight={30} zi={10}>
      <H4>Camera is not currently available on Web</H4>
    </YStack>
  );
}

export function DeviceSelect() {
  return null;
}

export function PrecisionSlider() {
  return null;
}
